import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';
import { paths } from '@shared/config/paths';
import { Button } from '@shared/ui/button/Button';
import { Input } from '@shared/ui/input/Input';
import {
  login,
  selectAuthError,
  selectAuthStatus,
  selectIsAuthenticated,
} from '../store/authSlice';

/**
 * Page de connexion. Redirige vers le dashboard si déjà authentifié.
 */
export function LoginPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const status = useAppSelector(selectAuthStatus);
  const error = useAppSelector(selectAuthError);

  useEffect(() => {
    if (isAuthenticated) {
      void navigate(paths.dashboard, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = String(data.get('email') ?? '');
    const password = String(data.get('password') ?? '');
    void dispatch(login({ email, password }));
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <img src="/logo.png" alt="" className="rounded-xl" width={148} height={48} />
          <div>
            <p className="mt-1 text-sm text-slate-500">Connectez-vous à votre espace</p>
          </div>
        </div>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-4 rounded-lg border border-slate-200 bg-white p-6 shadow-[0_1px_2px_rgba(15,23,42,0.04)]"
          noValidate
        >
          <Input
            label="Email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="admin@recivioai.app"
            required
          />
          <Input
            label="Mot de passe"
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder="••••••••"
            required
          />

          {error ? (
            <p role="alert" className="text-sm text-red-600">
              {error}
            </p>
          ) : null}

          <Button type="submit" disabled={status === 'loading'} className="w-full">
            {status === 'loading' ? 'Connexion…' : 'Se connecter'}
          </Button>

          <p className="text-center text-xs text-slate-400">
            Démo : admin@recivioai.app / recivioDemo123
          </p>
        </form>
      </div>
    </div>
  );
}
